"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkX5RGXUMZ_js = require('./chunk-X5RGXUMZ.js');
var chunkPBLNC4OF_js = require('./chunk-PBLNC4OF.js');
var n = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');
var faArrowDown = require('@fortawesome/free-solid-svg-icons/faArrowDown');
var faArrowUp = require('@fortawesome/free-solid-svg-icons/faArrowUp');
var react = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var n__default = /*#__PURE__*/_interopDefaultLegacy(n);

var f=n__default["default"].table`
  --background-level-1: var(--color-neutral-0);
  --border-default: var(--color-neutral-200);
  --border-table-active: var(--color-neutral-700);

  background: var(--background-level-1);
  border-collapse: collapse;
  color: var(--color-neutral-700);
  font-size: var(--font-size-regular);
  width: 100%;
`,y=n__default["default"].thead`
  color: var(--color-neutral-800);
`,u=n__default["default"].td`
  border-bottom: var(--border-width-x-small) solid var(--border-default);
  vertical-align: middle;
  overflow-wrap: anywhere;

  ${({xAlign:t})=>t&&{"text-align":t}}
  ${({yAlign:t})=>t&&{"vertical-align":t}}
  ${({$spacing:t})=>t&&{padding:`var(--spacing-${t}) var(--spacing-regular);`}}

  @media print {
    white-space: normal;
  }
`,S=n__default["default"].th`
  border-bottom: var(--border-width-x-small) solid var(--border-default);
  font-weight: var(--font-weight-bold);
  padding: var(--spacing-large) var(--spacing-regular) var(--spacing-small)
    var(--spacing-regular);

  ${({yAlign:t})=>t&&{"vertical-align":t}}

  ${({$sortable:t})=>t&&`
      cursor: pointer;
  
      &:hover {
        background: var(--color-neutral-50);
      }
      `}
  
    ${({$sortable:t,$sortDirection:o})=>t&&o&&`
      border-bottom: var(--border-width-small) solid var(--border-table-active);
      }
    `}
  
    @media print {
    width: auto;
  }
`,g=n__default["default"].span`
  flex: 1;
  display: flex;
  justify-content: center;

  ${({xAlign:t})=>t&&{"justify-content":t}}
`,C=n__default["default"](chunkX5RGXUMZ_js.a).attrs({spacing:"small",xAlign:"space-between",yAlign:"center"})`
  overflow-wrap: anywhere;
`;var P=({children:t,...o})=>jsxRuntime.jsx(f,{...o,children:t});var x=({children:t,...o})=>jsxRuntime.jsx(y,{...o,children:t});var D=({children:t,...o})=>jsxRuntime.jsx("tbody",{...o,children:t});var v=({children:t,...o})=>jsxRuntime.jsx("tfoot",{...o,children:t});var A=({children:t,...o})=>jsxRuntime.jsx("tr",{...o,children:t});var H=({xAlign:t="left",yAlign:o="middle",spacing:a="regular",children:i,...r})=>jsxRuntime.jsx(u,{xAlign:t,yAlign:o,$spacing:a,...r,children:i});var O={ASC:faArrowUp.faArrowUp,DESC:faArrowDown.faArrowDown},I={ASC:"ascending",DESC:"descending"},L=({xAlign:t="left",yAlign:o="middle",children:a,sortable:i=!1,sortDirection:r,...p})=>jsxRuntime.jsx(S,{$sortable:i,$sortDirection:r,yAlign:o,"aria-sort":r?I[r]:"none",...p,children:jsxRuntime.jsxs(C,{children:[jsxRuntime.jsx(g,{xAlign:t,children:a}),r&&jsxRuntime.jsx(chunkPBLNC4OF_js.a,{size:"small",icon:O[r]})]})});var z={Root:n__default["default"](P)``,Thead:n__default["default"](x)``,Tbody:n__default["default"](D)``,Tfoot:n__default["default"](v)``,Tr:n__default["default"](A)``,Td:n__default["default"](H)``,Th:n__default["default"](L)``};var U=(t,o,a,i)=>{let[{sortKey:r,sortDirection:p},T]=react.useState({sortKey:o,sortDirection:t}),c=e=>{let l=e.indexOf(p);return e[(l+1)%e.length]};return {sortKey:r,sortDirection:p,sortColumn:(e,l)=>{if(e===r){let m=c(a);T({sortKey:e,sortDirection:m}),i==null||i(e,m);return}T({sortKey:e,sortDirection:l!=null?l:t}),i==null||i(e,l!=null?l:t);},getColumnSortDirection:e=>r===e?p:void 0,getNextSortDirection:c}};

exports.a = z;
exports.b = U;
